export default "__VITE_ASSET__32013c63__"